/** @format */

import {ItemLoaders} from '../../core/loaders/ItemLoaders';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import {FormGeneralHelper} from '../../helpers/FormGeneral';
import moment from 'moment';
import i18next from 'i18next';
import {ExportToCsv} from 'export-to-csv';
import {simCardConstants} from '../simcard/actions';
import {SimCardCollectionInterface} from '../../interfaces/collections/SimCardCollectionInterface';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import {SimCardOperationHelper} from '../../helpers/SimCardOperationHelper';
import {iccidOperatorStatus} from '../../helpers/iccidStatus';
import {plkTariffIntToName, plkTariffNameToName} from '../../helpers/PlkTariffsMapper';
import {SimCardMnoTariffLoader} from "../tariffs/SimCardMnoTariffLoader";

interface StorageProductToCsvPartner {
    id: number;
    mvnoTariff: string | null;
    msisdn: string | null;
    imsi: string | null;
    // iccidType: string | null;
    partner: string | null;
    activateDate?: string | null;
    expiryDate?: string | null;
    removePeriod?: string | null;
    mvnoStatus: string | null;
    statusLocal: string | null;
    fupState: number;
}

export class StorageProductToCsv {
    private readonly itemLoader: ItemLoaders;
    private simCardMnoTariffLoader: SimCardMnoTariffLoader;

    constructor(itemLoader: ItemLoaders, simCardMnoTariffLoader: SimCardMnoTariffLoader) {
        this.itemLoader = itemLoader;
        this.simCardMnoTariffLoader = simCardMnoTariffLoader;
    }

    exportToCsv = (isSuperUser: boolean, orders: Array<Order>, filters: Array<Filter>, showMainLoader: (show: boolean) => void): void => {
        const extendFilter = [];

        filters.forEach((el) => {
            extendFilter.push(el);
        });
        extendFilter.push({ name: 'pagination', value: 'false' }, { name: 'csvExport', value: 'true' });

        showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_cards')),
            simCardConstants.SIM_CARD_LIST,
            extendFilter,
            orders,
            (items: SimCardCollectionInterface): void => {
                /**if (isSuperUser) {
                    this.platformResellerLoader.loadPlatformResellers({
                        filters: [],
                        callback: (): void => {
                            this.prepareSuperUserCsv(items);
                        },
                    });
                } else {**/
                this.preparePartnerUserCsv(items);
                /**}**/
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    preparePartnerUserCsv = (items: SimCardCollectionInterface): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: 'productReport_' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: 'Product report',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [
                i18next.t('simcard:list.identificator'),
                i18next.t('pools:sim.service_profile'),
                i18next.t('simcard:list.msisdn_number'),
                i18next.t('simcard:list.iccid_number'),
                // i18next.t('simcard:list.iccid_type'),
                i18next.t('simcard:list.partner'),
                i18next.t('simcard:list.activated_from'),
                i18next.t('simcard:list.activated_to'),
                i18next.t('simcard:list.deleted_at'),
                i18next.t('simcard:list.sim_card_status_mvno'),
                i18next.t('simcard:list.status_local'),
                i18next.t('simcard:list.fup_status'),
            ],
        };
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvList);
    };

    prepareCsvData = (items: SimCardCollectionInterface): Array<StorageProductToCsvPartner> => {
        const csvList: Array<StorageProductToCsvPartner> = [];
        if (items['hydra:member'] && items['hydra:totalItems'] && items['hydra:totalItems'] > 0) {
            items['hydra:member'].map((item: SimCardInterface) => {
                const mvnoTariff = i18next.t(plkTariffNameToName(plkTariffIntToName(item.mvnoTariffId)));
                const mvnoStatus = i18next.t(iccidOperatorStatus(item.mvnoStatus), { status: '(' + item.mvnoStatus + ')' });
                const statusLocal = i18next.t(SimCardOperationHelper.getSimCardStatus(item));
                csvList.push({
                    id: item.id,
                    mvnoTariff: item.mvnoTariffId ? this.simCardMnoTariffLoader.getName(item.mvnoTariffId) : '',
                    msisdn: item.deleted ? item.lastMsisdn : item.msisdn,
                    imsi: item.imsi,
                    // iccidType: item.iccidType,
                    partner: item.client.platformResellerName ?? '',
                    activateDate: item.activateDate ?? '',
                    expiryDate: item.expiryDate ?? '',
                    removePeriod: item.removePeriod ?? '',
                    mvnoStatus: mvnoStatus ?? '',
                    statusLocal: statusLocal ?? '',
                    fupState: item.fupState,
                });
            });
        }
        return csvList;
    };
}
